import "@shoelace-style/shoelace/dist/components/button/button.js";
import "@shoelace-style/shoelace/dist/components/icon/icon.js";

import { TemplateResult, css, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";
import { renderEnumSelect } from "./form/EnumSelect";
import { LocationType } from "../../models";
import { BooleanEnum } from "../Filter";
import { CaveRating } from "../../models";
import { TriState } from "../../models";
import { litIf } from "./LitUtils";
import { ExplorationPotential } from "../../models";
import { IPlaceFilter, clonePlaceFilter } from "../backend/cloud/PlaceFilterTable";
import { PlaceTable } from "../backend/cloud/PlaceTable";

@customElement("ds-filter-bar")
export class FilterBar extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            .container {
                margin: 0.5em;
                min-height: 1em;
                width: 100%;
                background-color: white;
                border-radius: 0.9em;
                padding: 1em;
                color: black;
            }

            .filters-container {
                flex-wrap: wrap;
            }

            .filters-container div {
                max-width: 300px;
            }

            .editor-grid-item {
                font-variant: all-petite-caps;
            }

            .show-toggle {
                width: 100%;
            }
            /* 
            .show-toggle span {
                color: white;
            } */

            .show-toggle div {
                display: flex;
                flex-direction: row;
                gap: var(--flex-gap);
                align-items: center;
                justify-content: center;
                float: right;
            }

            sl-button {
                align-self: flex-end;
                margin-left: auto;
            }
        `,
    ];

    private _places = this._kernel.dataStore.getSource<PlaceTable>("places");

    @state() protected _filter = this._kernel.currentPlaceFilter.get();
    @state() protected _open = true;
    @state() protected _numFilteredPlaces = 0;

    public override async connectedCallback(): Promise<void> {
        super.connectedCallback();
        this._subscribeToKernelEvent("filter-changed", async (filter: IPlaceFilter) => {
            this._filter = clonePlaceFilter(filter);
            this._numFilteredPlaces = await this._places.filteredItemsCount(this._filter.filter);
        });
        this.addEventListener("ds-item-changed", () => {
            this._kernel.currentPlaceFilter.set(this._filter);
        });
        this._numFilteredPlaces = await this._places.filteredItemsCount(this._filter.filter);
    }

    private _renderFilters(): TemplateResult {
        return html`<div class="filters-container flex-row">
            <div>
                ${renderEnumSelect(
                    this,
                    LocationType,
                    this._filter,
                    "type",
                    "Type",
                    undefined, //"What kind of feature this is",
                    undefined,
                    true,
                    1
                )}
            </div>
            <div>
                ${renderEnumSelect(
                    this,
                    CaveRating,
                    this._filter,
                    "caveRating",
                    "Dive rating",
                    undefined, //"What is the minimum cave diving level do you need to be to dive this cave",
                    undefined,
                    true,
                    1
                )}
            </div>
            <div>
                ${renderEnumSelect(
                    this,
                    TriState,
                    this._filter,
                    "goesToWater",
                    "Goes to water",
                    undefined,
                    undefined,
                    true,
                    1
                )}
            </div>
            <div>
                ${renderEnumSelect(
                    this,
                    TriState,
                    this._filter,
                    "verticalAccess",
                    "Vertical access",
                    undefined,
                    undefined,
                    true,
                    1
                )}
            </div>
            <div>
                ${renderEnumSelect(
                    this,
                    BooleanEnum,
                    this._filter,
                    "hasLocation",
                    "Location confirmed",
                    undefined,
                    undefined,
                    true,
                    1
                )}
            </div>
            <div>
                ${renderEnumSelect(
                    this,
                    ExplorationPotential,
                    this._filter,
                    "exploration",
                    "Exploration",
                    undefined,
                    undefined,
                    true,
                    1
                )}
            </div>
            <sl-button size="small" ?disabled=${this._numFilteredPlaces === 0}
                >Show ${this._numFilteredPlaces}</sl-button
            >
        </div>`;
    }

    override render(): TemplateResult {
        return html`<div class="container flex-column">
            <div class="header">
                <div style="margin-left:auto" class="show-toggle">
                    ${litIf(
                        this._open,
                        () =>
                            html`<div @click=${() => (this._open = false)}>
                                <span>hide filters</span><sl-icon name="chevron-up"></sl-icon>
                            </div>`,
                        () =>
                            html`<div @click=${() => (this._open = true)}>
                                <span>show filters</span><sl-icon name="chevron-down"></sl-icon>
                            </div>`
                    )}
                </div>
            </div>
            ${litIf(this._open, () => html`${this._renderFilters()}`)}
        </div> `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-filter-bar": FilterBar;
    }
}
